export default "__VITE_ASSET__DG7LEB_q__"